import { render, staticRenderFns } from "./SimpleScrollList.vue?vue&type=template&id=a9617792&scoped=true"
import script from "./SimpleScrollList.vue?vue&type=script&lang=js"
export * from "./SimpleScrollList.vue?vue&type=script&lang=js"
import style0 from "./SimpleScrollList.vue?vue&type=style&index=0&id=a9617792&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9617792",
  null
  
)

export default component.exports